// Defaults to production, so a normal `npm start` / `npm run build` behaves
// exactly as before. Point the panel at a local backend without editing this
// file by setting the variables in the environment (or in a .env file):
//
//   REACT_APP_API_URL=http://localhost:9090/ REACT_APP_IMAGE_URL=http://localhost:9090 npm start
//
// The trailing slash on the API URL matters — every path below is appended to it.
//
// !! LOCAL TESTING — swap these two pairs back before committing or deploying !!
const mainDomain =
  process.env.REACT_APP_API_URL || "https://api.asaagrotech.com/";
const imageDomain =
  process.env.REACT_APP_IMAGE_URL || "https://api.asaagrotech.com";
// const mainDomain = "http://localhost:9090/";
// const imageDomain = "http://localhost:9090";

const Constants = {
  imageDomain,
  getUrls: {
    getAboutUs: mainDomain + "about-us/",
    getAllTestimonials: mainDomain + "testimonial",
    getDashboard: mainDomain + "dashboard/my-dash",
    getAdminDasboard: mainDomain + "dashboard/admin-dash",
    getAllContacts: mainDomain + "contacts/list",

    getAllBlogs: mainDomain + "blogs/list-dash",
    getTrustedBrands: mainDomain + "trusted-brands/list",
    getPrivateBrands: mainDomain + "private-brands/list",
    careerEnquiry: mainDomain + "career-enquiry",
    getAllJobApplications: mainDomain + "job-applications/list",

    getAllCareerCategories: mainDomain + "career-categories/",
    getAllBlogCategories: mainDomain + "blog-categories/",
    getAllCareers: mainDomain + "careers/list",
    getAllNotifications: mainDomain + "notifications/list",
    getAllAlumini: mainDomain + "alumini",
    getAllEvents: mainDomain + "event",
    getGallery: mainDomain + "gallery",
    getAllCourses: mainDomain + "courses/list-dash",
    getAllFranchiseEnquiry: mainDomain + "franchise-enquiry",
    getSocialMedia: mainDomain + "social-media",
    getSchoolEnquiry: mainDomain + "school-enquiry",
    getAllBanners: mainDomain + "banner",
    getAllExams: mainDomain + "exams/list-dash",
    getAllCounts: mainDomain + "counts",
    getAllTeams: mainDomain + "teams",
    getAllFaqs: mainDomain + "faqs",
    getAllAmenities: mainDomain + "amenities",
    getAllNavbarTexts: mainDomain + "navbartext",
    getRequestDemo: mainDomain + "demos",

    // new
    getAllProjects: mainDomain + "projects/list-dash",
    getAllProducts: mainDomain + "products/list-dash",

    // Brand pages (Value Nest, Happinesque, Happy Wings, Versele-Laga and its
    // sub-brands, Bird Feeders), their product ranges and the editable
    // website pages.
    getAllBrands: mainDomain + "brands/list-dash",
    getBrandOptions: mainDomain + "brands/options",
    getBrand: mainDomain + "brands/",
    getAllBrandProducts: mainDomain + "brand-products/list-dash",
    // Leadership profiles on the website's About page.
    getAllLeaders: mainDomain + "leaders/list-dash",
    getLeader: mainDomain + "leaders/",
    getBrandProduct: mainDomain + "brand-products/",
    getAllSitePages: mainDomain + "pages/list-dash",
    getSitePage: mainDomain + "pages/",
    getPageSectionTypes: mainDomain + "pages/section-types",
  },
  postUrls: {
    createPrivateBrand: mainDomain + "private-brands/create",
    createTrustedBrand: mainDomain + "trusted-brands/create",
    createAboutUs: mainDomain + "about-us/create",
    createCareerCategory: mainDomain + "career-categories/create",
    createBlogCategory: mainDomain + "blog-categories/create",
    createBlogs: mainDomain + "blogs/create",
    createCareer: mainDomain + "careers/create",
    createNewNotification: mainDomain + "notifications/create-dash",
    employerLogin: mainDomain + "admin/login",
    createTestimonial: mainDomain + "testimonial/create",
    addNewAlumini: mainDomain + "alumini/create",
    addNewEvent: mainDomain + "event/create",
    addGallery: mainDomain + "gallery",
    addNewCourse: mainDomain + "courses/create",
    addSocialMedia: mainDomain + "social-media",
    addBanner: mainDomain + "banner/create",
    sendMailFranchise: mainDomain + "franchise-enquiry/sendMail",
    createExam: mainDomain + "exams/create",
    createCount: mainDomain + "counts/create",
    createTeam: mainDomain + "teams/create",
    createFaq: mainDomain + "faqs/create",
    createAmenity: mainDomain + "amenities/create",
    createNavbarText: mainDomain + "navbartext/create",
    createProject: mainDomain + "projects/create",
    createProduct: mainDomain + "products/create",

    createBrand: mainDomain + "brands/create",
    createBrandProduct: mainDomain + "brand-products/create",
    createSitePage: mainDomain + "pages/create",
    createLeader: mainDomain + "leaders/create",
    // Generic image upload used by the page-section builder.
    uploadMedia: mainDomain + "media/upload",
  },
  putUrls: {
    updatePrivateBrand: mainDomain + "private-brands/update/",
    updateTrustedBrand: mainDomain + "trusted-brands/update/",
    updateAboutUs: mainDomain + "about-us/update/",
    updateCareers: mainDomain + "careers/update/",
    updateCareerCategory: mainDomain + "career-categories/update/",
    updateBlogCategory: mainDomain + "blog-categories/update/",
    updateBlogs: mainDomain + "blogs/update/",
    updateTestimonial: mainDomain + "testimonial/update/",
    updateAlumini: mainDomain + "alumini/update/",
    updateEvent: mainDomain + "event/update/",
    updateCourses: mainDomain + "courses/update/",
    toggleCourseStatus: mainDomain + "courses/toggle-status",
    updateSocialMedia: mainDomain + "social-media",
    updateBanner: mainDomain + "banner/update",
    updateExam: mainDomain + "exams/update/",
    updateCount: mainDomain + "counts/update/",
    updateTeam: mainDomain + "teams/update/",
    updateFaq: mainDomain + "faqs/update/",
    updateAmenity: mainDomain + "amenities/update/",
    updateNavbarText: mainDomain + "navbartext/update/",
    updateProject: mainDomain + "projects/update/",
    updateProduct: mainDomain + "products/update/",

    updateBrand: mainDomain + "brands/update/",
    updateBrandProduct: mainDomain + "brand-products/update/",
    reorderBrandProducts: mainDomain + "brand-products/reorder",
    updateSitePage: mainDomain + "pages/update/",
    updateSitePageSections: mainDomain + "pages/sections/",
    updateLeader: mainDomain + "leaders/update/",
  },
  // Status toggles are PATCH endpoints.
  patchUrls: {
    toggleBrandStatus: mainDomain + "brands/status/",
    toggleBrandProductStatus: mainDomain + "brand-products/status/",
    toggleSitePageStatus: mainDomain + "pages/status/",
    toggleLeaderStatus: mainDomain + "leaders/status/",
  },
  deleteUrls: {
    deleteCareer: mainDomain + "careers/delete/",
    deleteCareerCategory: mainDomain + "career-categories/delete/",
    deletePrivateBrand: mainDomain + "private-brands/delete/",
    deletAboutUs: mainDomain + "about-us/delete/",
    deletePopup: mainDomain + "popup/delete/",
    deleteTestimonial: mainDomain + "testimonial/delete/",
    deleteGalleryImage: mainDomain + "gallery/",
    deleteAlumini: mainDomain + "alumini/delete/",
    deleteEvent: mainDomain + "event/delete/",
    deleteBlogCategory: mainDomain + "blog-categories/delete/",
    deleteBlog: mainDomain + "blogs/delete/",
    deleteCourse: mainDomain + "courses/",
    deleteSocialMedia: mainDomain + "social-media",
    deleteSchoolEnquiry: mainDomain + "school-enquiry",
    deleteBaner: mainDomain + "banner/delete",
    deleteExam: mainDomain + "exams/delete/",
    deleteCount: mainDomain + "counts/delete/",
    deleteTeam: mainDomain + "teams/delete/",
    deleteFaq: mainDomain + "faqs/delete/",
    deleteAmenity: mainDomain + "amenities/delete/",
    deleteNavbarText: mainDomain + "navbartext/delete/",
    deleteRequestDemo: mainDomain + "demos/delete/",
    deleteProject: mainDomain + "projects/delete/",
    deleteProduct: mainDomain + "products/delete/",
    deleteContact: mainDomain + "contact/delete",
    deleteTrustedBrand: mainDomain + "trusted-brands/delete/",

    deleteBrand: mainDomain + "brands/delete/",
    deleteBrandProduct: mainDomain + "brand-products/delete/",
    deleteSitePage: mainDomain + "pages/delete/",
    deleteLeader: mainDomain + "leaders/delete/",
    deleteMedia: mainDomain + "media",
  },
};

export default Constants;
